var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.37C13.455 5.3625 13.4025 5.3625 13.3575 5.37C12.3225 5.3325 11.4975 4.485 11.4975 3.435C11.4975 2.3625 12.36 1.5 13.4325 1.5C14.505 1.5 15.3675 2.37 15.3675 3.435C15.36 4.485 14.535 5.3325 13.5 5.37Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7275 10.83C13.755 11.0025 14.8875 10.8225 15.6825 10.29C16.74 9.585 16.74 8.43 15.6825 7.725C14.88 7.1925 13.7325 7.01249 12.705 7.19249",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4775 5.37C4.5225 5.3625 4.575 5.3625 4.62 5.37C5.655 5.3325 6.48 4.485 6.48 3.435C6.48 2.3625 5.6175 1.5 4.545 1.5C3.4725 1.5 2.61 2.37 2.61 3.435C2.6175 4.485 3.4425 5.3325 4.4775 5.37Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.83C4.2225 11.0025 3.09 10.8225 2.295 10.29C1.2375 9.585 1.2375 8.43 2.295 7.725C3.0975 7.1925 4.245 7.01249 5.2725 7.19249",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.9725C8.955 10.965 8.9025 10.965 8.8575 10.9725C7.8225 10.935 6.9975 10.0875 6.9975 9.03751C6.9975 7.96501 7.86 7.10251 8.9325 7.10251C10.005 7.10251 10.8675 7.97251 10.8675 9.03751C10.86 10.0875 10.035 10.9425 9 10.9725Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8175 13.335C5.76 14.04 5.76 15.195 6.8175 15.9C8.0175 16.7025 9.9825 16.7025 11.1825 15.9C12.24 15.195 12.24 14.04 11.1825 13.335C9.99 12.54 8.0175 12.54 6.8175 13.335Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleOrange);
export default __webpack_public_path__ + "static/media/people-orange.4d877e8b24cd3b84781c6337b5cd8668.svg";
export { ForwardRef as ReactComponent };